'use strict';

var SystemStatusDemandReinitializationDirective = function SystemStatusDemandReinitializationDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-demand-reinitialization.html'),
    controller: 'SystemStatusDemandReinitializationController',
    link: function link(scope, element) {
      var modalElement = element.find('#system-status-demand-reinit-confirmation-modal');
      scope.$on('grid:afterUpdateBoundData', scope.forceAddRow);
      scope.$on('system-status-demand-reinitialization:reinitialize', scope.reinitialize);
      scope.showModal = function () {
        modalElement.modal('show');
      };
    }
  };
};
SystemStatusDemandReinitializationDirective.$inject = [];
module.exports = SystemStatusDemandReinitializationDirective;